import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthenticationInfoService } from '@app/core/guards/authentication-info.service';
import { Router } from '@angular/router';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AccessRequirement } from '@app/core/models/access-requirement.model';
import * as _ from 'lodash';
import { AuthService } from '@app/core/guards/auth.service';

@Component({
  selector: 'app-dispatcher',
  templateUrl: './dispatcher.component.html',
  styleUrls: ['./dispatcher.component.scss'],
})
export class DispatcherComponent implements OnInit, OnDestroy {
  unsubscribe$: Subject<boolean> = new Subject<boolean>();

  dispatchedInvoicesUrl: string = '/invoices/dispatched';
  rejectedInvoicesUrl: string = '/invoices/rejected';
  voucherWorkflowUrl: string = '/invoices/voucherworkflow';
  promotionWorkflowUrl: string = '/invoices/promotionworkflow';
  voucherValidationUrl: string = '/invoices/vouchervalidated';
  searchUrl: string = '/invoices/search';
  unauthorizedUrl: string = '/unauthorized';
  administrationUrl: string = '/administration';
  homeUrl: string = '/home';

  isDoneLoading: boolean;
  isAuthenticated: boolean;
  userProfileLoaded: boolean;

  constructor(
    private authService: AuthService,
    private router: Router,
    private authenticationInfo: AuthenticationInfoService
  ) {}

  ngOnInit() {
    this.authService.isAuthenticated$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (isAuthenticated: boolean) => (this.isAuthenticated = isAuthenticated)
      );
    this.authService.isDoneLoading$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (isDoneLoading: boolean) => (this.isDoneLoading = isDoneLoading)
      );

    this.authenticationInfo.userProfileLoaded$
      .pipe(
        takeUntil(this.unsubscribe$),
        filter((userProfile) => !_.isNil(userProfile))
      )
      .subscribe((userProfile) => {
        this.userProfileLoaded = true;
        if (!userProfile.hasAnyGrantAccess) {
          this.router.navigate([this.unauthorizedUrl]);
          return;
        }

        if (userProfile.hasGrant(AccessRequirement.MultiMembership)) {
          this.router.navigate([this.homeUrl]);
          return;
        }

        if (userProfile.hasGrant(AccessRequirement.OperationalMembership)) {
          this.router.navigate([this.dispatchedInvoicesUrl]);
          return;
        }

        if (userProfile.hasGrant(AccessRequirement.SupervisionMembership)) {
          this.router.navigate([this.rejectedInvoicesUrl]);
          return;
        }

        if (userProfile.hasGrant(AccessRequirement.ValidationMembership)) {
          this.router.navigate([this.voucherWorkflowUrl]);
          return;
        }

        if (userProfile.hasGrant(AccessRequirement.PPRValidationMembership)) {
          this.router.navigate([this.promotionWorkflowUrl]);
          return;
        }

        if (userProfile.hasGrant(AccessRequirement.NonErpMemberShip)) {
          this.router.navigate([this.voucherValidationUrl]);
          return;
        }

        if (userProfile.hasGrant(AccessRequirement.ObservationMembership)) {
          this.router.navigate([this.searchUrl]);
          return;
        }

        if (userProfile.hasGrant(AccessRequirement.AdministrationMembership)) {
          this.router.navigate([this.administrationUrl]);
          return;
        }

        this.router.navigate([this.homeUrl]);
      });
  }

  login() {
    this.authService.login();
  }

  ngOnDestroy() {
    this.unsubscribe$.next(true);
  }
}
